


























import Modal from '@/project/modals/Modal.vue';
import { Component, Prop } from 'vue-property-decorator';
import { FacetValueViewObject } from '@/types/apiServerContract';

@Component({
    components: { }
})
export default class ProductAccessoriesCategoryOverlay extends Modal {
    @Prop({ type: Array })
    private readonly categories!: FacetValueViewObject[];

    private internalFilters: FacetValueViewObject[] = Object.assign(this.categories);

    handleChange(type: FacetValueViewObject) {
        this.closeOverlay(this.internalFilters as FacetValueViewObject[]);
    }

    resetFilters() {
        this.internalFilters.map(f => f.selected = false);
        this.closeOverlay(this.internalFilters as FacetValueViewObject[]);
    }
}
